export default __webpack_public_path__ + "static/media/volume-1.075b6003.svg";